module.exports = "/images/ny-street-10.jpg";